export default "__VITE_ASSET__MNuTAUrl__"